/**
 * values in query string
 */
export default {
  SEARCH: 's',
  PERFUMES: 'p',
  CONCEPTS: 'c',
}
